// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023photography/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getLimitInfo = () => {
  return http.get(`${urlPrefix}limit-vote`);
};
// const getVotesInfo = (
//   data: {
//     id: number | string;
//     udid?: any;
//     appkey?: any;
//     code?: any;
//     csessionid?: string;
//     scene?: string;
//     sig?: string;
//     token?: string;
//   }) => {
//   return http.get(`${urlPrefix}vote-times&unionid=${$unionid}`);
// };

// 活动投票
export function getVotesInfo(
  data: {
    id: number | string;
    udid?: any;
    appkey?: any;
    code?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  }
) {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}vote-times`, qsData);
}



const getVoteList = (workType: number, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType,
      page,
      search,
    },
  });
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const one = (id: any) => {
  return http.get(`${urlPrefix}detail-one`, {
    params: {
      id,
    },
  });
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const ifRegister = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}if_register`, qsData);
};

const register = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
  wxnickname?: any;
  wxheadimg?: any;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}register`, qsData);
};

const userInfo = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}user-info`, qsData);
};
const save = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const voteList = (page: any, search: any) => {
  return http.get(
    `${urlPrefix}vote-list&search=${search}&page=${page}`,
  );
};

const del1 = (data: {
  unionid?: any;
  udid?: any;
  appkey?: any;
  token?: string;
  id?: any;
}) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}user-delete`, qsData);
};

export {
  getBaseInfo,
  getVoteList,
  getDetail,
  getRule,
  ifRegister,
  register,
  userInfo,
  save,
  voteList,
  del1,
  one,
  getLimitInfo,
};
